/**
 * Custom hook to filter tools based on selected category and search term.
 *
 * @param {Array} fullToolsState - The complete list of tools.
 * @param {string} category - The selected category to filter tools by.
 * @param {string} searchTerm - The search term to filter tools by.
 * @param {Array} teacherKhanmigoAccess - List of tools the teacher has access to.
 * @returns {Array} - List of tools filtered by category and search term.
 */

import {useMemo} from "react";

import {ToolCategories} from "../ai-tools-list.ts";

const useFilteredToolsByCategoryAndSearch = (
    fullToolsState,
    category,
    searchTerm,
) => {
    return useMemo(() => {
        const filteredByCategory =
            category === ToolCategories.All
                ? fullToolsState
                : fullToolsState.filter((tool) => {
                      if (category === ToolCategories.Favorites) {
                          return tool.categories.includes(
                              ToolCategories.Favorites,
                          );
                      }
                      return tool.categories[0] === category;
                  });

        const trimmedSearchTerm = searchTerm.trim().toLowerCase();
        return trimmedSearchTerm.length === 0
            ? filteredByCategory
            : filteredByCategory.filter((tool) => {
                  return (
                      tool.title.toLowerCase().includes(trimmedSearchTerm) ||
                      tool.description.toLowerCase().includes(trimmedSearchTerm)
                  );
              });
    }, [fullToolsState, category, searchTerm]);
};

export default useFilteredToolsByCategoryAndSearch;
